var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreadcrumbAFY, icons, StepProgressAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { Title } from "../../layout/style";
import React from "react";
import { Icon } from "./iconOrLogo";
import { ContainerStepProgressAFY } from "./style";
export var HeaderTitlePage = function (props) {
    return (_jsxs("div", __assign({ style: { width: "100%" } }, { children: [_jsx(BreadcrumbAFY, { options: props.breadCrumbs }), _jsxs(Title, { children: [props.titlePage, _jsx(Icon, { logoImg: props.logoImg ? props.logoImg : "", showIcon: props.showIcon ? props.showIcon : false, iconPage: props.iconPage ? props.iconPage : icons.Search }), !props.hideStep && (_jsx(ContainerStepProgressAFY, __assign({ style: { top: props.stepsTop ? props.stepsTop : "-4px" } }, { children: _jsx(StepProgressAFY, { onClickStepProgress: function () { }, stepProgress: props.steps, collapsed: true, sticky: true, completed: props.completed }) })))] })] })));
};
